<h1>{{ data.title }}</h1>
<p>{{ data.message }}</p>
<button (click)="closeDialog()" class="close-popup" type="button">
  {{ data.buttonText ? data.buttonText : 'Schließen' }}
</button>
